module.exports = function calculateSaisondauer (saisonkennzeichenvon, saisonkennzeichenbis) {
  if (!saisonkennzeichenbis || !saisonkennzeichenvon) throw new Error('calculateSaisondauer: Missing arguments')
  let dauer = saisonkennzeichenbis - saisonkennzeichenvon + 1
  if (dauer < 0) dauer += 12
  return dauer
}
